import type { IconName } from "../components/Icon";

const actions: [RegExp, IconName][] = [
  [/^(?:inspect|explor|search|find|found|scan|list|look|brows)/i, "search"],
  [/^(?:creat|add|scaffold|initializ|set(?:ting)? up\b)/i, "plus"],
  [/^(?:read|load|open|view)/i, "book"],
  [/^(?:configur|set(?:ting)?\b)/i, "settings-2"],
  [/^(?:writ|wrote|edit|updat|fix|patch|balanc|adjust|replac)/i, "pencil"],
  [/^(?:test|verif|validat|check)/i, "check"],
  [/^(?:remov|delet|clean)/i, "trash"],
  [/^(?:cop(?:y|ied)|duplicat)/i, "copy"],
];

export function bashActivityIcon(description: string | undefined): IconName {
  const text = description?.trim() ?? "";
  return actions.find(([pattern]) => pattern.test(text))?.[1] ?? "code";
}
